import { TikTokEmbed } from 'react-social-media-embed';
import VideoPreviewYoutube from './VideoPreview/youtube';
import VideoPreviewBunnynet from './VideoPreview/bunnynet';
import manager from '../Manager';
import VideoPreviewBunnynetEmbed from './VideoPreview/bunnynetembed';

function NoVideo() {
    return (
        <div className="tbcourse-template-video-content">
            <div className="tbcourse-template-video-preview">
                <img src={require('../assets/img/video-frame.jpg')} className='img-fluid' alt='place an' />
            </div>
        </div>
    );
}

function VideoPreview({ data, index, structures }) {
    return (
        <div className="tbcourse-template tbcourse-template-video" key={index}>
            <div>
                <div className="tbcourse-template-text-title">{data?.title ? data.title : structures.title?.placeholder}</div>
                <div className="tbcourse-template-text-description" dangerouslySetInnerHTML={{ __html: data?.description ? data.description : manager.inEditor ? structures.description.placeholder :' ' }}></div>
                {data.platform ?
                    (<div className='tbcourse-template-video-content'>
                        <div className='tbcourse-template-video-preview'>
                            {data.platform === 'youtube' || data.platform === 'tiktok' || data.platform === 'bunnynet' ? (
                                typeof data.url !== 'undefined' && data.url.length > 0 ? (
                                    data.platform === 'youtube' ? (
                                        <VideoPreviewYoutube url={data.url} />
                                    ) : data.platform === 'tiktok' ? (
                                        <div className='tiktok-embed-container'>
                                            <TikTokEmbed url={data.url} width="100%" />
                                        </div>
                                    ) : data.platform === 'bunnynet' ? (
                                        <VideoPreviewBunnynetEmbed url={data.url}/>
                                    ) : (
                                        <NoVideo/>
                                    )
                                ) : <NoVideo />
                            ) : (
                                typeof data.video?.directPlayUrl !== 'undefined' ? <VideoPreviewBunnynet videoData={data.video} /> : <NoVideo />
                            )}
                        </div>
                    </div>) : <NoVideo />
                }
            </div>
        </div>
    )
}

export default VideoPreview;
